<template>
  <nav class="d-flex flex-row justify-center align-center">
    <v-container class="navbar d-flex">
      <v-row class="navbar-row" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
        <v-col cols="12" md="6" class="nav-cell nav-left" v-if="!$vuetify.breakpoint.smAndDown">
          <a class="brand" href="#"><img src="../assets/logo_ko.svg" alt="brand-logo" /></a>
        </v-col>
        <v-col cos="12" md="6" class="nav-cell nav-left" v-if="$vuetify.breakpoint.smAndDown">
          <p class="main-title">당신을 위한 <strong>다이어트 코칭</strong> 챗봇</p>
          <img class="desc-logo" src="../assets/2951@3x.png" alt="logo" />
        </v-col>
        <v-col cols="12" md="6" class="nav-cell nav-right">
          <ul class="social-btns">
            <li class="social-btn"><a class="icon-outer insta" href="https://www.instagram.com/dietfriends.app/" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']"></font-awesome-icon></a></li>
            <li class="social-btn"><a class="icon-outer facebook" href="https://www.facebook.com/dietfriends.official/?ref=py_c" target="_blank"><font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon></a></li>
            <li class="social-btn"><a class="icon-outer zendesk" href="https://support.dietfriends.kr/hc/ko" target="_blank"><font-awesome-icon :icon="['fas', 'question']"></font-awesome-icon></a></li>
            <li class="social-btn"><a class="icon-outer store" href="https://smartstore.naver.com/dietfriends" target="_blank"><font-awesome-icon :icon="['fas', 'store']"></font-awesome-icon></a></li>
          </ul>
        </v-col>
      </v-row>
    </v-container>
  </nav>
</template>

<script>
  export default {
      name: "DfNavbar"
  }
</script>

<style lang="scss" scoped>
  @import '../variables.scss';
  nav {
    position: relative;
    padding: 25px 0;
    z-index: 999;
    .navbar {
      box-shadow: none !important;
      background-color: transparent;
      margin: 0;
      padding: 0;
      height: auto;

      .navbar-row.show-mobile {
        padding: 0 3rem;
        .nav-left {
          order: 2;
          flex-direction: column;
          align-items: flex-start;
          .main-title {
            font-family: $basicFont;
            color: $basicFontColor;
            font-weight: bold;
            margin: 1rem 0;
            strong {
              background-color: $primaryBlueColor;
              padding: 0.5rem;
              color: white;
            }
          }
          img {
            width: 100%;
            height: auto;
          }
        }
        .nav-right {
          order: 1;
          margin-bottom: 1rem;
          justify-content: flex-start;
        }
      }
      .nav-cell {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .nav-left {
        .brand {
          font-size: 4em;
          font-family: $brandFont;
          color: $primaryBlueColor;
          text-decoration: none;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2rem 0 2rem 5rem;
          img {
            width: auto;
            height: 60px;
          }
        }
      }
      .nav-right {
        .social-btns {
          display: flex;
          flex-direction: row;
          padding: 0;
          justify-content: center;
          align-items: center;
        }
        .social-btn {
          margin-right: 1rem;
          font-size: 2.2em;
          color: $basicFontColor;
          border-radius: 1.1em;
        }
        .social-btn:hover {
          transition: ease-in-out 0.2s;
          .icon-outer {
            background-color: $primaryBlueColor;
          }
        }
        .icon-outer {
          width: 1em;
          border-radius: 0.6em;
          height: 1em;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: $basicFontColor;

          svg {
            color: white;
            font-size: 0.5em;
          }
        }
        .icon-outer.insta {
          svg {
            font-size: 0.7em;
          }
        }
      }
    }
  };
</style>
